import useModal from '@/common/hooks/useModal';
import getVehicleTypeQueryOption from '@/common/queries/getVehicleType/getVehicleTypeQueryOPtion';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

const useVehicleTypeMiss = ({
  userId,
  fileId,
}: {
  userId?: string;
  fileId: string;
}) => {
  const [error, setError] = useState(false);
  const [route, setRoute] = useState('');
  const modalState = useModal();

  const updateError = (state: boolean) => {
    setError(state);
  };
  const { isPending: loading } = useQuery(
    getVehicleTypeQueryOption({
      damaged_pk: userId,
      file_pk: fileId!,
      onError: (err) => {
        if (err?.detail === 'vehicle type is not defined') {
          updateError(true);
        }
      },
      onSuccess: () => {
        updateError(false);
      },
    }),
  );
  const updateModal = ({ route }: { route: string }) => {
    modalState.openModal();
    setRoute(route);
  };
  return {
    error,
    modalState: {
      vehicleTypeErrorModalCloseModal: modalState.closeModal,
      isVehicleTypeErrorModalOpen: modalState.open,
      vehicleTypeErrorModalOpenModal: updateModal,
    },
    loading,
    route,
  };
};

export default useVehicleTypeMiss;
